import { urls } from 'utils/urls';

import { buildApiRequest, buildFileUploadRequest } from 'utils/api';

export function getDemandDetailsRequest(params) {
  return buildApiRequest('GET', `${urls.getDemands}/${params.params.demandId}/basic-details`);
}

export function getConsignersRequest(text) {
  return buildApiRequest('GET', urls.getConsignerList, { expression: text, pageNo: 0, size: 30, type: null });
}

export function getUserDetailsRequest(params) {
  return buildApiRequest('GET', `${urls.getDemands}/${params.params.demandId}/user-details`);
}

export function updateDemandDetailsRequest(demandId, payload) {
  return buildApiRequest('PUT', `${urls.getDemands}/${demandId}/basic-details`, payload);
}

export function updatePTLMetadataRequest(demandId, payload) {
  return buildApiRequest('PUT', urls.getPtlMetaDataRequestUrl(demandId), payload);
}

export function uploadFreightData(demandId, formData) {
  return buildFileUploadRequest(`${urls.getDemands}/${demandId}/sfa-upload-url`, formData);
}

export function updateFreightDetailsRequest(demandId, payload) {
  return buildApiRequest('PUT', `${urls.getDemands}/${demandId}/freight-details`, payload);
}

export function getTransactionsRequest(params) {
  return buildApiRequest('GET', urls.getTransactions, {
    'consignment-id': params.params.consignmentId,
    'demand-id': params.params.demandId,
    'party-type': params.params.type,
  });
}

export function addExpenseRequest(payload) {
  return buildApiRequest('POST', urls.addExpense, payload.payload);
}

export function editExpenseRequest(payload) {
  return buildApiRequest('PUT', `${urls.addExpense}/${payload.payload.expenseId}`, payload.payload.payload);
}

export function settleExpenseRequest(payload) {
  return buildApiRequest('PUT', urls.settleShipper, payload.payload);
}

export function getRemarksRequest(params) {
  return buildApiRequest('GET', `${urls.getTransactions}/remarks`, params.params);
}

export function getBankDetailsRequest(params) {
  return buildApiRequest('GET', urls.getBankAccounts, params.params);
}

export function getEmailsListRequest(params) {
  return buildApiRequest('GET', `${urls.getEmails}`, params.params);
}

export function assignIndentRequest(dId, payload) {
  return buildApiRequest('PUT', `${urls.getDemands}/${dId}/assign`, payload);
}

export function deleteExpenseRequest(payload) {
  return buildApiRequest('DELETE', `${urls.addExpense}/${payload.payload.id}`, {
    deleted: true,
    partyType: payload.payload.partyType,
  });
}

export function editTransactionRequest(transactionId, payload) {
  return buildApiRequest('PUT', `${urls.getTransactions}/${transactionId}`, payload);
}

export function createTransactionRequest(payload) {
  return buildApiRequest('POST', `${urls.getTransactions}`, payload.payload);
}

export function expenseTypesRequest(params) {
  // Use v2 so response matches stage: array of { expenseCategory, selectOptions, ... } including CANCELLATION CHARGE - REVERSAL
  return buildApiRequest('GET', `${urls.addExpense}/types`, params.params);
}

export function getExpenseDetailsRequest(params) {
  return buildApiRequest('GET', urls.getShipperExpense, { 'demand-id': params.params.demandId });
}

export function getFormConfigRequest() {
  return buildApiRequest('GET', urls.getFormConfig);
}
export function getVehiclesByDemandIdRequest(params) {
  return buildApiRequest('GET', urls.getVehiclesByDemandId(params.params.demandId));
}
export function getMaterialDetailsRequest(params) {
  return buildApiRequest('GET', urls.getMaterialDetailsUrl(params.params));
}
export function getMaterialTypesRequest(params) {
  return buildApiRequest('GET', urls.getMaterialTypesRequestUrl(params.params));
}

export function createMaterialDetailsRequest(payload) {
  let materials = payload.payload.materials;
  return buildApiRequest('POST', urls.createMaterialDetailsRequestUrl(payload.payload), materials);
}

export function getPtlMetaDataRequest(demandId) {
  console.log(demandId);
  return buildApiRequest('GET', urls.getPtlMetaDataRequestUrl(demandId));
}

export function getGstDetails(demandId) {
  return buildApiRequest('GET', urls.getGstDetails(demandId));
}
